import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { shareReplay, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TravelService {

  private apiRoot = environment.admin_url;
  // private apiRoot = 'http://192.168.18.60:8000/admin/api/v1/';

  constructor(private http: HttpClient) { }

  sendTravelPackageData(payload: any) {
    return this.http.post(`${this.apiRoot}Admin/travel-request`, payload).pipe(
      tap((response: any) => { }),
      shareReplay()
    );

  }

  getallcountries(){
    return this.http.get(`${this.apiRoot}Admin/getCountries`).pipe(
      tap((response:any)=>{}),
      shareReplay()
    )
  }

  getallcities(id:any){
    return this.http.get(`${this.apiRoot}Admin/getCity?countryId=${id}`).pipe(
      tap((response:any)=>{}),
      shareReplay()
    )
  }
}

